import useModalContext from '@ui/components/Modal/useModalContext'
import { useMaxWindowDimensions } from '@ui/theme/useRWD'
import {
  Platform,
  StyleProp,
  useWindowDimensions,
  ViewStyle,
} from 'react-native'
import { useReanimatedKeyboardAnimation } from 'react-native-keyboard-controller'
import Animated, {
  SharedValue,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withSpring,
} from 'react-native-reanimated'

interface Props {
  children: React.ReactNode
  style?: StyleProp<ViewStyle>
  animation?: SharedValue<number>
}

export default function AnimatedModalPanel({
  children,
  style,
  animation,
}: Props) {
  const { width, height } = useMaxWindowDimensions()

  const { width: realW } = useWindowDimensions()

  const { height: keyboardHeight } = useReanimatedKeyboardAnimation()

  const { animation: modalAnimation, isClosing } = useModalContext()

  const contentHeight = useSharedValue(height - 234 * 2)
  const styleModal = useAnimatedStyle(() => {
    const aV = isClosing.value
      ? animation?.value === 0
        ? animation.value
        : modalAnimation?.value
      : animation?.value ?? modalAnimation?.value

    return {
      top: (height - contentHeight.value) / 2,
      paddingBottom: -keyboardHeight.value,
      transform: [{ translateY: interpolate(aV, [0, 100], [200, 0]) }],
      pointerEvents: aV < 50 ? 'none' : 'auto',
      opacity: interpolate(aV, [25, 100], [0, 1]),
    }
  })
  const containerW = Platform.select({ default: width - 128, web: width - 256 })

  return (
    <Animated.View
      onLayout={({ nativeEvent: { layout } }) => {
        contentHeight.value = withSpring(layout.height, {
          damping: 500,
          stiffness: 1000,
          mass: 3,
        })
      }}
      style={[
        {
          position: 'absolute',
          width: containerW,
          left: Math.floor((realW - containerW) / 2),
        },
        styleModal,
        style,
      ]}
    >
      {children}
    </Animated.View>
  )
}
